import { FunctionComponent } from 'react';

import { SearchInput } from '@kanda-libs/ks-component-ts';
import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
} from '@kanda-libs/ks-design-library';

import LoanTable from 'components/loan/LoanTable';
import LoanTableActions from 'components/loan/LoanTableActions';
import { URLS } from 'components/shared/App/constants';
import InfoBanner from 'components/shared/InfoBanner';
import PageTitle from 'components/shared/PageTitle';
import PresetFilter, {
  PresetFilterOption,
} from 'components/shared/PresetFilter';
import useQuery from 'hooks/useQuery';

const LoansLayout: FunctionComponent = function () {
  const [query, setQuery] = useQuery('loans');
  const currentPath = window.location.href
    .split(window.location.host)[1]
    .split('?')[0];

  const options: PresetFilterOption[] = [
    { value: URLS.loans, text: 'Ongoing Loans' },
    { value: URLS.loansFinished, text: 'Finished Loans' },
    { value: URLS.loansAll, text: 'All Loans' },
  ];

  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <PageTitle>Loans</PageTitle>
        <PresetFilter
          menuItem="loans"
          currentPath={currentPath}
          options={options}
        />
        <InfoBanner
          title="Loans"
          nameContent={<LoanTableActions />}
          search={<SearchInput query={query} onSearch={setQuery} />}
        />
        <LoanTable />
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default LoansLayout;
